import { apiClient } from '../api/client';
import { API_PATHS } from '../api/endpoints';
import { mapTimestamps } from '../api/mapTimestamps';
import type { ApiItemResponse } from '../types/apiResponses';

interface Company {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

type BackendCompany = Omit<Company, 'createdAt' | 'updatedAt'> & {
  created: string;
  lastModified: string;
};

export async function getCompanyById(id: string): Promise<Company> {
  const response = await apiClient.get<ApiItemResponse<BackendCompany>>(
    `${API_PATHS.company}${id}`,
  );
  return mapTimestamps(response.item);
}
